export default "__VITE_ASSET__9c4b17db__"